import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-footer',
  templateUrl: './admin-footer.component.html',
  styleUrls: ['./admin-footer.component.sass']
})
export class AdminFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
